<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.filters }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-flex class="mt-3" xs12>
                      <message :messages="messages"></message>
                    </v-flex>
                    <v-form>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex xs12 md6>
                            <v-autocomplete
                              :loading="loading"
                              :items="accumTypes"
                              v-model="form.accumType"
                              :label="labels.accumType"
                              item-text="label"
                              item-value="value"
                              data-vv-name="accumType"
                              :data-vv-as="labels.accumType"
                              :error-messages="errors.collect('accumType')"
                              @change="onChangeAccmType"
                              v-validate="'required'"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md6> </v-flex>
                          <v-flex xs12 md6 lg6>
                            <v-text-field
                              :loading="loading"
                              :disabled="disable.blkGrp"
                              v-model="form.blkGrpFrm"
                              :label="labels.blkGrpFrm"
                              :error-messages="errors.collect('blkGrpFrm')"
                              data-vv-name="blkGrpFrm"
                              :data-vv-as="labels.blkGrpFrm"
                              append-icon="mdi-magnify"
                              v-validate="vBlkGrpFrm"
                              @click:append="getHelpList('blkGrpFrm')"
                              @change="changeBlkGrp('blkGrpFrm')"
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 lg6>
                            <v-text-field
                              :loading="loading"
                              :disabled="disable.blkGrp"
                              v-model="form.blkGrpTo"
                              :label="labels.blkGrpTo"
                              :error-messages="errors.collect('blkGrpTo')"
                              data-vv-name="blkGrpTo"
                              :data-vv-as="labels.blkGrpTo"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('blkGrpTo')"
                              v-validate="vBlkGrpTo"
                              @change="changeBlkGrp('blkGrpTo')"
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 lg6>
                            <v-text-field
                              :loading="loading"
                              :disabled="disable.blkSubGrp1"
                              v-model="form.blkSubGrp1Frm"
                              :label="labels.blkSubGrp1Frm"
                              :error-messages="errors.collect('blkSubGrp1Frm')"
                              data-vv-name="blkSubGrp1Frm"
                              :data-vv-as="labels.blkSubGrp1Frm"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('blkSubGrp1Frm')"
                              v-validate="vBlkSubGrp1Frm"
                              @change="changeBlkSubGrp1('blkSubGrp1Frm')"
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 lg6>
                            <v-text-field
                              :loading="loading"
                              :disabled="disable.blkSubGrp1"
                              v-model="form.blkSubGrp1To"
                              :label="labels.blkSubGrp1To"
                              :error-messages="errors.collect('blkSubGrp1To')"
                              data-vv-name="blkSubGrp1To"
                              :data-vv-as="labels.blkSubGrp1To"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('blkSubGrp1To')"
                              v-validate="vBlkSubGrp1To"
                              @change="changeBlkSubGrp1('blkSubGrp1To')"
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 lg6>
                            <v-text-field
                              :loading="loading"
                              :disabled="disable.blkSubGrp2"
                              v-model="form.blkSubGrp2Frm"
                              :label="labels.blkSubGrp2Frm"
                              :error-messages="errors.collect('blkSubGrp2Frm')"
                              data-vv-name="blkSubGrp2Frm"
                              :data-vv-as="labels.blkSubGrp2Frm"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('blkSubGrp2Frm')"
                              v-validate="vBlkSubGrp2Frm"
                              @change="changeBlkSubGrp2('blkSubGrp2Frm')"
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 lg6>
                            <v-text-field
                              :loading="loading"
                              :disabled="disable.blkSubGrp2"
                              v-model="form.blkSubGrp2To"
                              :label="labels.blkSubGrp2To"
                              :error-messages="errors.collect('blkSubGrp2To')"
                              data-vv-name="blkSubGrp2To"
                              :data-vv-as="labels.blkSubGrp2To"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('blkSubGrp2To')"
                              v-validate="vBlkSubGrp2To"
                              @change="changeBlkSubGrp2('blkSubGrp2To')"
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 lg6>
                            <v-text-field
                              :loading="loading"
                              :disabled="disable.blk"
                              v-model="form.blkFrm"
                              :label="labels.blkFrm"
                              :error-messages="errors.collect('blkFrm')"
                              data-vv-name="blkFrm"
                              :data-vv-as="labels.blkFrm"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('blkFrm')"
                              v-validate="vBlkFrm"
                              @change="changeBlk('blkFrm')"
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 lg6>
                            <v-text-field
                              :loading="loading"
                              :disabled="disable.blk"
                              v-model="form.blkTo"
                              :label="labels.blkTo"
                              :error-messages="errors.collect('blkTo')"
                              data-vv-name="blkTo"
                              :data-vv-as="labels.blkTo"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('blkTo')"
                              v-validate="vBlkTo"
                              @change="changeBlk('blkTo')"
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6 lg6>
                            <cal-picker
                              v-model="form.asADate"
                              :label="labels.asADate"
                              v-validate="'required'"
                              :data-vv-as="labels.asADate"
                              data-vv-name="asADate"
                              :error-messages="errors.collect('asADate')"
                            ></cal-picker>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-flex xs12 sm12 md12 lg12 class="pt-3">
            <v-btn color="primary" type="submit" :loading="loading" @click.prevent="doSubmit">
              {{ labels.normalise }}
              <v-icon right dark>mdi-content-save</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
        <v-dialog v-model="dialogBlkGrp" width="900px">
          <block-group-help-list
            v-if="dialogBlkGrp"
            :accmType="form.accumType"
            @close="doClose"
            @assign-blkGrp="doAssign($event)"
          ></block-group-help-list>
        </v-dialog>
        <v-dialog v-model="dialogBlkSubGrp1" width="900px">
          <block-sub-group-1-help-list
            v-if="dialogBlkSubGrp1"
            :accmType="form.accumType"
            :blkGrpFrm="form.blkGrpFrm"
            :blkGrpTo="form.blkGrpTo"
            @close="doClose"
            @assign-blksGrp1="doAssign($event)"
          ></block-sub-group-1-help-list>
        </v-dialog>
        <v-dialog v-model="dialogBlkSubGrp2" width="900px">
          <block-sub-group-2-help-list
            v-if="dialogBlkSubGrp2"
            :accmType="form.accumType"
            :blkGrpFrm="form.blkGrpFrm"
            :blkGrpTo="form.blkGrpTo"
            :blksGrp1Frm="form.blkSubGrp1Frm"
            :blksGrp1To="form.blkSubGrp1To"
            @close="doClose"
            @assign-blksGrp2="doAssign($event)"
          ></block-sub-group-2-help-list>
        </v-dialog>
        <v-dialog v-model="dialogBlk" width="900px">
          <block-help-list
            v-if="dialogBlk"
            :accmType="form.accumType"
            :blkGrpFrm="form.blkGrpFrm"
            :blkGrpTo="form.blkGrpTo"
            :blksGrp1Frm="form.blkSubGrp1Frm"
            :blksGrp1To="form.blkSubGrp1To"
            :blksGrp2Frm="form.blkSubGrp2Frm"
            :blksGrp2To="form.blkSubGrp2To"
            @close="doClose"
            @assign-blk="doAssign($event)"
          ></block-help-list>
        </v-dialog>
      </v-layout>
    </v-container>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import BlockGroupHelpList from '@/components/core/common/dialog/BlockGroupHelpList'
import BlockSubGroup1HelpList from '@/components/core/common/dialog/BlockSubGroup1HelpList'
import BlockSubGroup2HelpList from '@/components/core/common/dialog/BlockSubGroup2HelpList'
import BlockHelpList from '@/components/core/common/dialog/BlockHelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import clone from 'clone'

export default {
  data() {
    return {
      labels: {
        filters: 'Filters',
        normalise: 'Normalise',
        accumType: 'Accumulation Type',
        blkGrpFrm: 'Block Group From',
        blkGrpTo: 'Block Group To',
        blkSubGrp1Frm: 'Block Sub Group 1 From',
        blkSubGrp1To: 'Block Sub Group 1 To',
        blkSubGrp2Frm: 'Block Sub Group 2 From',
        blkSubGrp2To: 'Block Sub Group 2 To',
        blkFrm: 'Block From',
        blkTo: 'Block From To',
        asADate: 'As A Date'
      },
      form: {
        accumType: '',
        blkGrpFrm: '',
        blkGrpTo: '',
        blkSubGrp1Frm: '',
        blkSubGrp1To: '',
        blkSubGrp2Frm: '',
        blkSubGrp2To: '',
        blkFrm: '',
        blkTo: '',
        asADate: new Date()
      },
      disable: {
        blkGrp: true,
        blkSubGrp1: true,
        blkSubGrp2: true,
        blk: true
      },
      dialogBlkGrp: false,
      dialogBlkSubGrp1: false,
      dialogBlkSubGrp2: false,
      dialogBlk: false,
      accumTypes: [],
      loading: false,
      selHelpList: undefined,
      isblkGrpFrm: true,
      isblkGrpTo: true,
      isblkSubGrp1Frm: true,
      isblkSubGrp1To: true,
      isblkSubGrp2Frm: true,
      isblkSubGrp2To: true,
      isblkFrm: true,
      isblkTo: true,
      panel1: [0]
    }
  },
  computed: {
    accumTypeParamMenu() {
      return this.$store.state.accumTypeParam.menu
    },
    blkParamMenu() {
      return this.$store.state.blkParam.menu
    },
    underwritingMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.menu
    },
    vBlkGrpFrm() {
      return 'required|validValue:' + this.isblkGrpFrm + ',"Invalid Block Group"'
    },
    vBlkGrpTo() {
      return 'required|validValue:' + this.isblkGrpTo + ',"Invalid Block Group"'
    },
    vBlkSubGrp1Frm() {
      return 'required|validValue:' + this.isblkSubGrp1Frm + ',"Invalid Block Sub Group 1"'
    },
    vBlkSubGrp1To() {
      return 'required|validValue:' + this.isblkSubGrp1To + ',"Invalid Block Sub Group 1"'
    },
    vBlkSubGrp2Frm() {
      return 'required|validValue:' + this.isblkSubGrp2Frm + ',"Invalid Block Sub Group 2"'
    },
    vBlkSubGrp2To() {
      return 'required|validValue:' + this.isblkSubGrp2To + ',"Invalid Block Sub Group 2"'
    },
    vBlkFrm() {
      return 'required|validValue:' + this.isblkFrm + ',"Invalid Block"'
    },
    vBlkTo() {
      return 'required|validValue:' + this.isblkTo + ',"Invalid Block"'
    }
  },
  watch: {},
  beforeMount() {},
  created() {
    this.doInit()
  },
  methods: {
    changeBlkGrp(compId) {
      if (
        (compId === 'blkGrpFrm' && this.form.blkGrpFrm !== undefined && this.form.blkGrpFrm !== '') ||
        (compId === 'blkGrpTo' && this.form.blkGrpTo !== undefined && this.form.blkGrpTo !== '')
      ) {
        let data = {
          action: 'BLKGRP'
        }
        let blkGrp = ''
        if (compId === 'blkGrpFrm') {
          blkGrp = this.form.blkGrpFrm
        } else {
          blkGrp = this.form.blkGrpTo
        }

        let filter = {
          accmType: this.form.accumType,
          blkGrpEq: blkGrp
        }
        this.validData(compId, this.underwritingMenu.checkNormalise, data, filter)
        this.loading = false
      }
    },
    changeBlkSubGrp1(compId) {
      if (
        (compId === 'blkSubGrp1Frm' && this.form.blkSubGrp1Frm !== undefined && this.form.blkSubGrp1Frm !== '') ||
        (compId === 'blkSubGrp1To' && this.form.blkSubGrp1To !== undefined && this.form.blkSubGrp1To !== '')
      ) {
        let data = {
          action: 'BLKSUBGRP1'
        }

        let blkSubGrp1 = ''
        if (compId === 'blkSubGrp1Frm') {
          blkSubGrp1 = this.form.blkSubGrp1Frm
        } else {
          blkSubGrp1 = this.form.blkSubGrp1To
        }

        let filter = {
          accmType: this.form.accumType,
          blkGrpFrm: this.form.blkGrpFrm,
          blkGrpTo: this.form.blkGrpTo,
          blksGrp1: blkSubGrp1
        }
        this.validData(compId, this.underwritingMenu.checkNormalise, data, filter)
        this.loading = false
      }
    },
    changeBlkSubGrp2(compId) {
      if (
        (compId === 'blkSubGrp2Frm' && this.form.blkSubGrp2Frm !== undefined && this.form.blkSubGrp2Frm !== '') ||
        (compId === 'blkSubGrp2To' && this.form.blkSubGrp2To !== undefined && this.form.blkSubGrp2To !== '')
      ) {
        let data = {
          action: 'BLKSUBGRP2'
        }

        let blkSubGrp2 = ''
        if (compId === 'blkSubGrp2Frm') {
          blkSubGrp2 = this.form.blkSubGrp2Frm
        } else {
          blkSubGrp2 = this.form.blkSubGrp2To
        }

        let filter = {
          accmType: this.form.accumType,
          blkGrpFrm: this.form.blkGrpFrm,
          blkGrpTo: this.form.blkGrpTo,
          blksGrp1Frm: this.form.blkSubGrp1Frm,
          blksGrp1To: this.form.blkSubGrp1To,
          blksGrp2: blkSubGrp2
        }
        this.validData(compId, this.underwritingMenu.checkNormalise, data, filter)
        this.loading = false
      }
    },
    changeBlk(compId) {
      if (
        (compId === 'blkFrm' && this.form.blkFrm !== undefined && this.form.blkFrm !== '') ||
        (compId === 'blkTo' && this.form.blkTo !== undefined && this.form.blkTo !== '')
      ) {
        let data = {
          action: 'BLK'
        }

        let blk = ''
        if (compId === 'blkFrm') {
          blk = this.form.blkFrm
        } else {
          blk = this.form.blkTo
        }

        let filter = {
          accumType: this.form.accumType,
          blkGrpFrm: this.form.blkGrpFrm,
          blkGrpTo: this.form.blkGrpTo,
          blksGrp1Frm: this.form.blkSubGrp1Frm,
          blksGrp1To: this.form.blkSubGrp1To,
          blksGrp2Frm: this.form.blkSubGrp2Frm,
          blksGrp2To: this.form.blkSubGrp2To,
          blk: blk
        }
        this.validData(compId, this.underwritingMenu.checkNormalise, data, filter)
        this.loading = false
      }
    },
    doInit() {
      this.getCommonDataList('accumTypes')

      if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
        this.$store.dispatch('specialFuncUWInit')
      }

      if (this.$store.state.accumTypeParam.init !== 1) {
        this.$store.dispatch('accumTypeManagementInit')
      }

      if (this.$store.state.blkParam.init !== 1) {
        this.$store.dispatch('blkParamManagementInit')
      }

      const validValue = {
        getMessage: (field, args) => {
          return args[1]
        },
        validate: (value, args) => {
          if (value) {
            var val = args[0]
            if (val === 'true') {
              return true
            } else {
              return false
            }
          }
        }
      }
      this.$validator.extend('validValue', validValue)
    },
    async fetchAccumType() {
      const apiURI = this.accumTypeParamMenu.accumType
      if (apiURI) {
        this.loading = true
        try {
          const expand = { accumTypeReviewParam: this.form.accumType }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.resetMessages()
            this.disable.blkGrp = data.accumTypeReviewParam.blkGrpLblS === undefined || data.accumTypeReviewParam.blkGrpLblS === ''
            this.disable.blkSubGrp1 = data.accumTypeReviewParam.blkSgrp1LblS === undefined || data.accumTypeReviewParam.blkSgrp1LblS === ''
            this.disable.blkSubGrp2 = data.accumTypeReviewParam.blkSgrp2LblS === undefined || data.accumTypeReviewParam.blkSgrp2LblS === ''
            this.disable.blk = data.accumTypeReviewParam.blkLblS === undefined || data.accumTypeReviewParam.blkLblS === ''
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    async doAssign(val) {
      if (this.selHelpList === 'blkGrpFrm') {
        this.form.blkGrpFrm = val
        this.changeBlkGrp('blkGrpFrm')
      } else if (this.selHelpList === 'blkGrpTo') {
        this.form.blkGrpTo = val
        this.changeBlkGrp('blkGrpTo')
      } else if (this.selHelpList === 'blkSubGrp1Frm') {
        this.form.blkSubGrp1Frm = val
        this.changeBlkSubGrp1('blkSubGrp1Frm')
      } else if (this.selHelpList === 'blkSubGrp1To') {
        this.form.blkSubGrp1To = val
        this.changeBlkSubGrp1('blkSubGrp1To')
      } else if (this.selHelpList === 'blkSubGrp2Frm') {
        this.form.blkSubGrp2Frm = val
        this.changeBlkSubGrp2('blkSubGrp2Frm')
      } else if (this.selHelpList === 'blkSubGrp2To') {
        this.form.blkSubGrp2To = val
        this.changeBlkSubGrp2('blkSubGrp2To')
      } else if (this.selHelpList === 'blkFrm') {
        this.form.blkFrm = val
        this.changeBlk('blkFrm')
      } else if (this.selHelpList === 'blkTo') {
        this.form.blkTo = val
        this.changeBlk('blkTo')
      }
      this.selHelpList = ''
      this.doClose()
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.process()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    getHelpList(val) {
      this.selHelpList = val
      if (this.selHelpList === 'blkGrpFrm' || this.selHelpList === 'blkGrpTo') {
        this.dialogBlkGrp = true
      } else if (this.selHelpList === 'blkSubGrp1Frm' || this.selHelpList === 'blkSubGrp1To') {
        this.dialogBlkSubGrp1 = true
      } else if (this.selHelpList === 'blkSubGrp2Frm' || this.selHelpList === 'blkSubGrp2To') {
        this.dialogBlkSubGrp2 = true
      } else if (this.selHelpList === 'blkFrm' || this.selHelpList === 'blkTo') {
        this.dialogBlk = true
      }
    },
    doClose() {
      this.dialogBlkGrp = false
      this.dialogBlkSubGrp1 = false
      this.dialogBlkSubGrp2 = false
      this.dialogBlk = false
    },
    onChangeAccmType(val) {
      this.clearDataOnChangeAccmType()
      this.fetchAccumType()
    },
    clearDataOnChangeAccmType() {
      this.form.blkGrpFrm = ''
      this.form.blkGrpTo = ''
      this.form.blkSubGrp1Frm = ''
      this.form.blkSubGrp1To = ''
      this.form.blkSubGrp2Frm = ''
      this.form.blkSubGrp2To = ''
      this.form.blkFrm = ''
      this.form.blkTo = ''
    },
    async process() {
      const apiUrl = this.underwritingMenu.normalise
      if (apiUrl) {
        this.loading = true
        try {
          let form = clone(this.form)
          const result = await this.$http.post(apiUrl, form)
          if (result && result.data) {
            this.notify(result.data)
          } else {
            this.$toast.error('Unexpected server response')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('Missing API URL (Treaty Cession Normalisation)')
      }
      this.loading = false
    },
    async validData(compId, url, data, form) {
      const apiUrl = url
      if (apiUrl) {
        try {
          this.loading = true
          let massageFilters = clone(form)
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, data), massageFilters))
          if (result && result.data) {
            const { data } = result.data
            if (compId === 'blkGrpFrm') {
              this.isblkGrpFrm = data
            } else if (compId === 'blkGrpTo') {
              this.isblkGrpTo = data
            } else if (compId === 'blkSubGrp1Frm') {
              this.isblkSubGrp1Frm = data
            } else if (compId === 'blkSubGrp1To') {
              this.isblkSubGrp1To = data
            } else if (compId === 'blkSubGrp2Frm') {
              this.isblkSubGrp2Frm = data
            } else if (compId === 'blkSubGrp2To') {
              this.isblkSubGrp2To = data
            } else if (compId === 'blkFrm') {
              this.isblkFrm = data
            } else if (compId === 'blkTo') {
              this.isblkTo = data
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    BlockGroupHelpList,
    BlockSubGroup1HelpList,
    BlockSubGroup2HelpList,
    BlockHelpList
  }
}
</script>
